<template>
	<div class="checker-upload-list">
		<ul>
			<li v-for="file in files" :key="file.id" class="checker-upload-list__item">
				<span>{{ file.name }}</span>
				<span class="checker-upload-list__progress">{{ formatSize(file.size) }}</span>
				<div>
					<span :style="{ width: file.progress + '%' }"></span>
				</div>
				<button @click="file.uploadCompleted ? onRemove(file) : onCancel(file)">
					<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" v-if="file.uploadCompleted" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M17.464 5.5H20.5m-3.036 0h.036a1 1 0 011 1V19c0 1.312-1.159 2.5-2.5 2.5H8c-1.341 0-2.5-1.188-2.5-2.5V6.5a1 1 0 011-1h.036m10.928 0l-1.964-3h-7l-1.964 3m10.928 0H6.536m0 0H3.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
					<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" v-else="" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M5 5l14 14m0-14L5 19" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>
				</button>
			</li>
		</ul>
	</div>
</template>

<script>
export default {
	name: "CheckerUploadList",
    props: {
        files: {
            type: Array,
        },
    },
	methods: {
		formatSize(size) {
			if (size < 1024) {
				return size + " B";
			} else if (size < 1024 * 1024) {
				return (size / 1024).toFixed() + " KB";
			} else {
				return (size / (1024 * 1024)).toFixed(2) + " MB";
			}
		},

		onRemove(file) {
			this.$emit("remove", file);
		},

		onCancel(file) {
			this.$emit("cancel", file);
		},
	},
};
</script>

<style lang="scss" scoped>
.checker-upload-list {
    display: flex;
    flex-direction: column;
    gap: rem(16);
}

.checker-upload-list__item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border: 1px solid $color-blue-40;
    border-radius: 4px;
    padding: rem(12) rem(16) rem(12) rem(24);
    background: $color-blue-00;
    width: rem(430);
}

.checker-upload-list__progress {
    color: $color-cool-grey-50;
    @include font-size(s);
}
</style>
